module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/area_an-6bd3ebcf751b83d54c12eaa4daf648c9.jpg";